import { render, staticRenderFns } from "./BcaTransfer.vue?vue&type=template&id=47ce4323"
import script from "./BcaTransfer.vue?vue&type=script&lang=js"
export * from "./BcaTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports